export const namespaces = {
  common: 'common',
  validation: 'validation',
  countries: 'countries',
  appContainerWithMenu: 'appContainerWithMenu',
  workloads: 'workloads',
  alerts: 'alerts',
  attacks: 'attacks',
  alertsForDevices: 'alertsForDevices',
  alertsForFleetsView: 'alertsForFleetsView',
  auditLog: 'auditLog',
  auth: 'auth',
  user: 'user',
  clients: 'clients',
  integrations: 'integrations',
  query: 'query',
  settings: 'settings',
  dashboard: 'dashboard',
  device: 'device',
  deviceDetails: 'deviceDetails',
  widget: 'widget',
  product: 'product',
  fleetsView: 'fleetsView',
  logs: 'logs',
  logsForFleetsView: 'logsForFleetsView',
  logsForDeviceDetails: 'logsForDeviceDetails',
  anomalies: 'anomalies',
  notes: 'notes',
  metricUnits: 'metricUnits',
} as const;
